import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=25981f98&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25981f98')) {
      api.createRecord('25981f98', component.options)
    } else {
      api.reload('25981f98', component.options)
    }
    module.hot.accept("./PageHeading.vue?vue&type=template&id=25981f98&", function () {
      api.rerender('25981f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page-heading/PageHeading.vue"
export default component.exports